export default __webpack_public_path__ + "atomic/_patterns/02-molecules/link-block-button/_link-block-button.twig";